module.exports = __webpack_public_path__ + "img/shjficon.1485ce8d.svg";